import { type DocumentNode, gql } from '@apollo/client';

const deleteViewFieldMutation: DocumentNode = gql`
  mutation delete_view_field($viewFieldId: ID!) {
    deleteViewField(viewFieldId: $viewFieldId) {
      viewField {
        id
        view {
          id
        }
        fieldLabel
      }
    }
  }
`;

export default deleteViewFieldMutation;
